export default function getAppUrl(path: string = "") {
  const url = import.meta.env.PUBLIC_APP_URL;
  return `${url}${path}`;
}
